// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* InputArea.css */
.input-area {
  display: flex;
  align-items: center;
  padding: 10px;
  background-color: transparent;
  border-top: none;
  max-width: 100%;
  position: relative;
}
 
.chat-input-container {
  position: relative;
  flex-grow: 1;
  display: flex;
  align-items: center;
 
}
 
.chat-input {
  flex-grow: 1;
  padding: 15px;
  font-size: 14px;
  border: none;
  border-radius: 22px;
  padding: 15px 90px 15px 40px;
  background-color: var(--input-background-color);
  color: var(--text-color);
  outline: none;
  resize: none;
  font-family: 'Inter', Arial, sans-serif;
  height: 25px;
  line-height: 26px;
  min-height: 20px;
  max-height: 190px; /* optional max to prevent extreme growth */
 
}
 
.attachment-button {
  position: absolute;
  left: 10px;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  color: var(--button-color);
  top: 17px;
}
 
.send-button {
  position: absolute;
  right: 45px;
  background-color: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--button-color);
}
 
.mic-button {
  position: absolute;
  right: 9px;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  color: var(--button-color);
  font-size: 22px; /* Slightly bigger for better visibility */
  transition: color 0.3s ease-in-out, transform 0.2s ease-in-out;
}
 
.mic-button.recording {
  color: red; /* Subtle color change to indicate recording */
  transform: scale(1.1); /* Slight zoom-in effect */
}
 
/*.mic-button:hover {
  color: #ff4d4d; /* Light red on hover */
  /*transform: scale(1.1);*/
/*}*/
 
 
@keyframes pulse-glow {
  0% {
    transform: scale(1);
    box-shadow: 0 0 8px 3px rgba(0, 255, 0, 0.5);
  }
  50% {
    transform: scale(1.1);
    box-shadow: 0 0 10px 5px rgba(0, 255, 0, 0.7);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 8px 3px rgba(0, 255, 0, 0.5);
  }
}
 
.chat-input::-webkit-scrollbar {
  display: none;
}
 
.chat-input {
  scrollbar-width: none; /* Firefox */
}
 
 
.chat-input {
  -ms-overflow-style: none;
}
 
 
.mic-processing {
  position: absolute;
  right: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 25px;
  height: 25px;
}
 
.spinner-icon {
  font-size: 18px;
  color: #007bff;
  animation: spin 1s linear infinite;
}
 
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
 
.attachment-button {
  margin-right: 10px;
  bottom: 15px;
}

.send-button,
.stop-button,
.mic-button {
  position: static; /* REMOVE absolute */
}

 
 
 
 
 
 
 
 
 
 
 
 
 
 
 
 
 
 
 
 
 
 
 
 
 
.recording-bar {
  display: flex;
  align-items: center;
  background: #d3d3d3;
  border-radius: 20px;
  padding: 18px 28px;
  width: 100%;
  min-height: 60px;
  gap: 20px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.16);
}
 
.waveform-container {
  flex: 1 1;
  min-width: 0;
  display: flex;
  align-items: center;
}
 
.recording-actions {
  display: flex;
  gap: 8px;
}
 
.recording-cancel,
.recording-confirm {
  background: none;
  border: none;
  color: #131313;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.4em;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}
 
.recording-cancel:hover {
  background: #d3d3d3;
  color: #ff7676;
}
.recording-confirm:hover {
  background: #d3d3d3;
  color: #87ff87;
}
 
 
 
.input-area .chat-input-container,
.input-area .recording-bar {
  width: 100%;
  min-height: 85px;        /* Match your normal bar height */
  box-sizing: border-box;
  border-radius: 20px;
  background: #f2f2f2;     /* Or whatever color you use */
  display: flex;
  align-items: center;
  padding: 5px 10px;
}
 
.processing-spinner-container {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 44px;       /* or whatever matches your waveform height */
}
 











.chat-input-container {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  background-color: #f4f4f4;
  border-radius: 20px;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.05);
}

.chat-input {
  flex: 1 1;
  margin: 0 12px;
  border: none;
  background: transparent;
  font-size: 15px;
  resize: none;
  outline: none;
  color: #333;
}

.chat-right-buttons {
  display: flex;
  align-items: center;
  gap: 8px;
}

.send-button,
.stop-button,
.mic-button {
  background: none;
  border: none;
  padding: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.stop-button {
  width: 36px;
  height: 36px;
  background-color: white;
  border-radius: 50%;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
  padding: 0;
}

.stop-icon {
  width: 14px;
  height: 14px;
  background-color: black;
  border-radius: 2px;
}


[data-theme="dark"] .stop-button {
  background-color: #333;
}

[data-theme="dark"] .stop-icon {
  background-color: white;
}

`, "",{"version":3,"sources":["webpack://./src/components/styles/InputArea.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;;AAErB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,4BAA4B;EAC5B,+CAA+C;EAC/C,wBAAwB;EACxB,aAAa;EACb,YAAY;EACZ,uCAAuC;EACvC,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB,EAAE,2CAA2C;;AAEhE;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,eAAe,EAAE,0CAA0C;EAC3D,8DAA8D;AAChE;;AAEA;EACE,UAAU,EAAE,8CAA8C;EAC1D,qBAAqB,EAAE,0BAA0B;AACnD;;AAEA;yCACyC;EACvC,yBAAyB;AAC3B,IAAI;;;AAGJ;EACE;IACE,mBAAmB;IACnB,4CAA4C;EAC9C;EACA;IACE,qBAAqB;IACrB,6CAA6C;EAC/C;EACA;IACE,mBAAmB;IACnB,4CAA4C;EAC9C;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB,EAAE,YAAY;AACrC;;;AAGA;EACE,wBAAwB;AAC1B;;;AAGA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;;;EAGE,gBAAgB,EAAE,oBAAoB;AACxC;;;;;;;;;;;;;;;;;;;;;;;;;;;AA2BA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,uCAAuC;AACzC;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;;EAEE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;;;AAIA;;EAEE,WAAW;EACX,gBAAgB,SAAS,iCAAiC;EAC1D,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB,MAAM,8BAA8B;EACvD,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB,QAAQ,6CAA6C;AACvE;;;;;;;;;;;;;AAaA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,SAAO;EACP,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;;EAGE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,yCAAyC;EACzC,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;AACpB;;;AAGA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":["/* InputArea.css */\r\n.input-area {\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 10px;\r\n  background-color: transparent;\r\n  border-top: none;\r\n  max-width: 100%;\r\n  position: relative;\r\n}\r\n \r\n.chat-input-container {\r\n  position: relative;\r\n  flex-grow: 1;\r\n  display: flex;\r\n  align-items: center;\r\n \r\n}\r\n \r\n.chat-input {\r\n  flex-grow: 1;\r\n  padding: 15px;\r\n  font-size: 14px;\r\n  border: none;\r\n  border-radius: 22px;\r\n  padding: 15px 90px 15px 40px;\r\n  background-color: var(--input-background-color);\r\n  color: var(--text-color);\r\n  outline: none;\r\n  resize: none;\r\n  font-family: 'Inter', Arial, sans-serif;\r\n  height: 25px;\r\n  line-height: 26px;\r\n  min-height: 20px;\r\n  max-height: 190px; /* optional max to prevent extreme growth */\r\n \r\n}\r\n \r\n.attachment-button {\r\n  position: absolute;\r\n  left: 10px;\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  color: var(--button-color);\r\n  top: 17px;\r\n}\r\n \r\n.send-button {\r\n  position: absolute;\r\n  right: 45px;\r\n  background-color: transparent;\r\n  border: none;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: var(--button-color);\r\n}\r\n \r\n.mic-button {\r\n  position: absolute;\r\n  right: 9px;\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  color: var(--button-color);\r\n  font-size: 22px; /* Slightly bigger for better visibility */\r\n  transition: color 0.3s ease-in-out, transform 0.2s ease-in-out;\r\n}\r\n \r\n.mic-button.recording {\r\n  color: red; /* Subtle color change to indicate recording */\r\n  transform: scale(1.1); /* Slight zoom-in effect */\r\n}\r\n \r\n/*.mic-button:hover {\r\n  color: #ff4d4d; /* Light red on hover */\r\n  /*transform: scale(1.1);*/\r\n/*}*/\r\n \r\n \r\n@keyframes pulse-glow {\r\n  0% {\r\n    transform: scale(1);\r\n    box-shadow: 0 0 8px 3px rgba(0, 255, 0, 0.5);\r\n  }\r\n  50% {\r\n    transform: scale(1.1);\r\n    box-shadow: 0 0 10px 5px rgba(0, 255, 0, 0.7);\r\n  }\r\n  100% {\r\n    transform: scale(1);\r\n    box-shadow: 0 0 8px 3px rgba(0, 255, 0, 0.5);\r\n  }\r\n}\r\n \r\n.chat-input::-webkit-scrollbar {\r\n  display: none;\r\n}\r\n \r\n.chat-input {\r\n  scrollbar-width: none; /* Firefox */\r\n}\r\n \r\n \r\n.chat-input {\r\n  -ms-overflow-style: none;\r\n}\r\n \r\n \r\n.mic-processing {\r\n  position: absolute;\r\n  right: 15px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 25px;\r\n  height: 25px;\r\n}\r\n \r\n.spinner-icon {\r\n  font-size: 18px;\r\n  color: #007bff;\r\n  animation: spin 1s linear infinite;\r\n}\r\n \r\n@keyframes spin {\r\n  0% { transform: rotate(0deg); }\r\n  100% { transform: rotate(360deg); }\r\n}\r\n \r\n.attachment-button {\r\n  margin-right: 10px;\r\n  bottom: 15px;\r\n}\r\n\r\n.send-button,\r\n.stop-button,\r\n.mic-button {\r\n  position: static; /* REMOVE absolute */\r\n}\r\n\r\n \r\n \r\n \r\n \r\n \r\n \r\n \r\n \r\n \r\n \r\n \r\n \r\n \r\n \r\n \r\n \r\n \r\n \r\n \r\n \r\n \r\n \r\n \r\n \r\n \r\n.recording-bar {\r\n  display: flex;\r\n  align-items: center;\r\n  background: #d3d3d3;\r\n  border-radius: 20px;\r\n  padding: 18px 28px;\r\n  width: 100%;\r\n  min-height: 60px;\r\n  gap: 20px;\r\n  box-shadow: 0 2px 12px rgba(0,0,0,0.16);\r\n}\r\n \r\n.waveform-container {\r\n  flex: 1;\r\n  min-width: 0;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n \r\n.recording-actions {\r\n  display: flex;\r\n  gap: 8px;\r\n}\r\n \r\n.recording-cancel,\r\n.recording-confirm {\r\n  background: none;\r\n  border: none;\r\n  color: #131313;\r\n  border-radius: 50%;\r\n  width: 40px;\r\n  height: 40px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 1.4em;\r\n  cursor: pointer;\r\n  transition: background 0.2s, color 0.2s;\r\n}\r\n \r\n.recording-cancel:hover {\r\n  background: #d3d3d3;\r\n  color: #ff7676;\r\n}\r\n.recording-confirm:hover {\r\n  background: #d3d3d3;\r\n  color: #87ff87;\r\n}\r\n \r\n \r\n \r\n.input-area .chat-input-container,\r\n.input-area .recording-bar {\r\n  width: 100%;\r\n  min-height: 85px;        /* Match your normal bar height */\r\n  box-sizing: border-box;\r\n  border-radius: 20px;\r\n  background: #f2f2f2;     /* Or whatever color you use */\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 5px 10px;\r\n}\r\n \r\n.processing-spinner-container {\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  min-height: 44px;       /* or whatever matches your waveform height */\r\n}\r\n \r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n.chat-input-container {\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 10px 16px;\r\n  background-color: #f4f4f4;\r\n  border-radius: 20px;\r\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.chat-input {\r\n  flex: 1;\r\n  margin: 0 12px;\r\n  border: none;\r\n  background: transparent;\r\n  font-size: 15px;\r\n  resize: none;\r\n  outline: none;\r\n  color: #333;\r\n}\r\n\r\n.chat-right-buttons {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.send-button,\r\n.stop-button,\r\n.mic-button {\r\n  background: none;\r\n  border: none;\r\n  padding: 6px;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.stop-button {\r\n  width: 36px;\r\n  height: 36px;\r\n  background-color: white;\r\n  border-radius: 50%;\r\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);\r\n  padding: 0;\r\n}\r\n\r\n.stop-icon {\r\n  width: 14px;\r\n  height: 14px;\r\n  background-color: black;\r\n  border-radius: 2px;\r\n}\r\n\r\n\r\n[data-theme=\"dark\"] .stop-button {\r\n  background-color: #333;\r\n}\r\n\r\n[data-theme=\"dark\"] .stop-icon {\r\n  background-color: white;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
